var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('mf-fetching'),_vm._v(" "),_c('mf-nav-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowNavigation),expression:"shouldShowNavigation"}]}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-419e2917","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Root.vue
// module id = null
// module chunks = 